import React, { useState } from "react"
import { Button } from "@mallardbay/lib-react-components"
import type { PaymentMethod } from "@stripe/stripe-js"

// TODO: Switch to use the shared component lib modal
import MbModal from "~components/shared/mb-modal"
import PaymentElementForm from "~components/pages/book/payment-element-form"
import { SetupIntentProvider } from "~stripe/setup-intent-provider"
import COPY from "~config/copy-constants"
import useCreateSetupIntent from "~utils/use-create-setup-intent"
import { useUser } from "~config/user-provider"

interface Props {
    readonly title?: string
    readonly onPaymentMethodAdded?: (paymentMethod: PaymentMethod) => void
    readonly shouldSkipSetupIntentIfNoUserId?: boolean
}

export default function AddPaymentMethodButton({
    title = COPY.ADD_PAYMENT_METHOD,
    onPaymentMethodAdded = () => {},
    shouldSkipSetupIntentIfNoUserId,
}: Props) {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { user } = useUser()

    const handleClose = () => {
        setIsOpen(false)
    }

    return (
        <>
            <Button onClick={() => setIsOpen(true)}>{title}</Button>
            <MbModal title={title} isOpen={isOpen} onClose={handleClose}>
                {isOpen && (
                    <SetupIntentProvider
                        useSetupIntentHook={useCreateSetupIntent}
                        setupIntentHookArgs={{
                            userId: user?.id,
                            shouldSkipIfNoUserId:
                                shouldSkipSetupIntentIfNoUserId,
                        }}
                    >
                        <PaymentElementForm
                            onClose={handleClose}
                            onPaymentMethodAdded={onPaymentMethodAdded}
                        />
                    </SetupIntentProvider>
                )}
            </MbModal>
        </>
    )
}
